import { QUANTUM_UI } from '../../../flags';
import { AlertContainer as AlertContainerNew } from './AlertContainer';
import { AlertContainer as AlertContainerOld } from './AlertContainer.old';
export var AlertContainer = QUANTUM_UI ? AlertContainerNew : AlertContainerOld;
export * from './alertContainerStyles';
